export default "__VITE_ASSET__BLBAT1ug__"